import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class ChronoCodeLevel extends BasicEntity {
label: TranslatedEmb;
level: number | null;
parentCode: string;
timeGapCode: string;
}

